import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import axios from 'axios'

function useGetVariations(sessionId) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['variations', String(sessionId)],
    queryFn: async () => {
      const { data: responseData } = await axios.get('/api/internal/generator/runs', {
        params: { generator_session_id: sessionId },
      })

      return responseData.data || []
    },
    enabled: sessionId != null,
  })

  const variations = useMemo(() =>
    (data ?? [])
      .map((item) => ({ ...item.attributes, id: item.id }))
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)),
    [data],
  )

  return { variations, isLoading, isError }
}

export default useGetVariations
